import { Action } from '@ngrx/store';
import { SiteSupportedLanguageInterface } from 'app/site-settings/models/site-supported-language.model';

import { SiteSettingActionType } from './site-setings-action-type.enum';

export class LoadSiteSupportedLanguage implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSiteSupportedLanguage;

  public readonly payload: any = undefined;
}

export class LoadSiteSupportedLanguageCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSiteSupportedLanguageCompleted;

  constructor(public readonly payload: SiteSupportedLanguageInterface[]) { }
}

export class LoadSiteSupportedLanguageFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSiteSupportedLanguageFailed;

  constructor(public readonly payload: string) { }
}
export class UpdateSiteSupportedLanguage implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSiteSupportedLanguage;

  constructor(public readonly payload: SiteSupportedLanguageInterface[]) {  }
}

export class UpdateSiteSupportedLanguageCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSiteSupportedLanguageCompleted;

  constructor(public readonly payload: SiteSupportedLanguageInterface[]) { }
}

export class UpdateSiteSupportedLanguageFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSiteSupportedLanguageFailed;

  constructor(public readonly payload: string) { }
}
